<template>
  <div style="margin-top:-10px !important">
    <b-row class="px-pad border-bottom" style="height:42px">
      <b-col md="6" lg="6" sm="6" cols="6" class="px-0">
        <span class="fw-semi-bold index-heading pl-0">Reporting Tags</span>
      </b-col>
      <b-col md="6" lg="6" sm="6" cols="6" class="text-right px-0">
        <b-button
          variant="primary"
          size="sm"
          @click="report_tag =createFreshData();page='create';error_msg = false"
          v-b-modal.reportingtag
        >New Tag</b-button>
      </b-col>
    </b-row>
    <!-- Table for details -->
    <b-row>
      <b-col cols="12" class="px-0">
        <div class="table-responsive px-0 min-table">
          <table class="table table-hover not-fixed-col not-fixed-last-col index-table">
            <thead>
              <tr>
                <th class="text-left" style="padding-left:1.6rem !important;width:150px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{
                      name: 'ReportingTag',
                      query: {
                       
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'tag_name',
                        
                      },
                    }"
                  >
                    Tag Name
                    <small class="text-muted" v-if="label == 'tag_name'">
                      <i
                        :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                        style="font-weight: thinner"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th class="text-left" style="width:200px !important">
                  <router-link
                    class="text-dark text-decoration-none"
                    :to="{
                      name: 'ReportingTag',
                      query: {
                       
                        sort: sort == 'asc' ? 'desc' : 'asc',
                        label: 'tag_fields',
                        
                      },
                    }"
                  >
                    Options
                    <small class="text-muted" v-if="label == 'tag_fields'">
                      <i
                        :class="[{ 'fa fa-fw': true }, 'fa-sort-' + sort]"
                        style="font-weight: thinner"
                      ></i>
                    </small>
                  </router-link>
                </th>
                <th
                  class="text-right"
                  style="width:30px !important;padding-right:1.6rem !important"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="lists.length===0">
                <td colspan="3" class="text-center">There are no reporting tags</td>
              </tr>
              <tr
                v-else
                :class="{'text-muted':item.status==0}"
                v-for="(item,index) in lists"
                :key="item.tag_id"
              >
                <td
                  class="text-left"
                  style="width:150px !important;padding-left:1.6rem !important"
                >{{ item.tag_name }}</td>
                <td class="text-left" style="width:200px">
                  <span class="text pr-3">{{ item.tag_fields }}</span>
                </td>

                <td class="text-right cursor_pointer" style="padding-right:1.6rem !important">
                  <b-dropdown
                    right
                    toggle-class="text-decoration-none"
                    variant="link"
                    no-caret
                    size="xs"
                    class="table-hover-visible last-td-arrow"
                  >
                    <template slot="button-content">
                      <i
                        class="glyphicon glyphicon-option-vertical theme-text-color"
                        style="top:-6px !important;letter-spacing:-5px !important"
                      ></i>
                    </template>
                    <span class="event-link dropdown-item" @click="fetchTagData(item.tag_id)">Edit</span>
                    <span
                      @click="changeTagStatus(item.tag_id,item.status==1?'0':'1')"
                      class="event-link dropdown-item"
                    >Mark as {{item.status==1?'Inactive':'Active'}}</span>
                    <span
                      class="event-link dropdown-item"
                      v-b-modal.reportingtagdelete
                      @click="delete_id=item.tag_id"
                    >Delete</span>
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
    <!-- Modal for add or edit reporting tag -->
    <b-modal
      :no-close-on-backdrop="true"
      id="reportingtag"
      size="md"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      :ok-title-html="submitted==true?loaderIcon+(page=='create'?'Add':'Update'):(page=='create'?'Add':'Update')"
      :title="(page=='create'?'Create':'Update') +' Reporting Tag'"
      ref="reportingtag"
      @ok.prevent="onSubmit"
      :ok-disabled="submitted"
      scrollable
    >
      <div class="container-fluid">
        <b-alert
          class="alert-transparent alert-danger"
          :show="(error_show && errors.any())||error_msg||option_duplicate"
        >
          <button
            type="button"
            @click="error_show=!error_show;error_msg=false;option_duplicate=false"
            class="close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <p
            v-for="item in errors.items"
            :key="item.id"
            class="fw-semi-bold"
          >{{ item.field=='option 1'&&item.rule=='required'?'Please provide at least one option.':item.msg }}</p>
          <p class="fw-semi-bold" v-if="error_msg">{{ message }}</p>
          <p
            class="fw-semi-bold"
            v-if="option_duplicate"
          >The same option has been used more than once.</p>
        </b-alert>
      </div>
      <b-form>
        <b-row class="mx-0">
          <b-col>
            <b-form-group label="Label Name" label-for="label-name" label-class="required">
              <b-form-input
                data-vv-name="label name"
                v-validate="'required|max:100'"
                v-model="report_tag.tag_name"
              ></b-form-input>
              <small class="text-muted">E.g: Location, Department</small>
            </b-form-group>
            <b-form-group class="mt-3" label-class="required" label="Options" label-for="options">
              <div
                class="d-flex mb-2"
                v-for="(option,index) in report_tag.tag_options"
                :key="index"
              >
                <b-input-group>
                  <b-input-group-prepend is-text v-if="option.hasOwnProperty('value')">
                    <input type="checkbox" v-model="option.is_active" />
                  </b-input-group-prepend>
                  <b-form-input
                    :data-vv-name="'option '+(index+1)"
                    :disabled="!option.is_active"
                    v-validate="{required:index==0,max:100}"
                    v-model="option.label"
                  ></b-form-input>
                </b-input-group>
                <i
                  class="glyphicon glyphicon-trash ml-2 my-auto cursor_pointer"
                  @click="removeOption(index,option)"
                ></i>
              </div>
            </b-form-group>
            <b-button size="xs" variant="outline-primary" @click="addOption()">Add another option</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <!--  delete modal -->

    <b-modal
      :no-close-on-backdrop="true"
      id="reportingtagdelete"
      size="md"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      :ok-title-html="submitted==true?loaderIcon+'yes':'yes'"
      title="Delete Reporting Tag"
      ref="delete"
      @ok="deleteReportingTag()"
      :ok-disabled="submitted"
    >
      <p>Are you sure about deleting selected Reporting tag?</p>
    </b-modal>
  </div>
</template>
<script>
// import all the components, files and funciton
import { mapState } from "vuex"; // get data set in the state in vuex
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global function for calling notification

//pages
function getPageTags(routeTo, next) {
  const label = routeTo.query.label || "";
  const sort = routeTo.query.sort || "";
  store
    .dispatch("reportingtag/fetchLists", {
      sort: sort,
      label: label
    })
    .then(() => {
      routeTo.params.label = label;
      routeTo.params.sort = sort;
      next();
    });
}

export default {
  props: { label: [String, Number], sort: [String, Number] },
  mixins: [notificationMixin], //call the global mixin function
  name: "ReportTag",
  data() {
    return {
      delete_id: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      report_tag: {},
      page: "create",
      error_msg: false,
      option_duplicate: false,
      error_show: false
    };
  },
  components: {},
  methods: {
    createFreshData() {
      return {
        tag_name: "",
        tag_options: [
          {
            is_active: true,
            label: ""
          }
        ],
        status: 1
      };
    },
    fetchTagData(id) {
      this.$store.dispatch("reportingtag/fetchTagDetails", id).then(() => {
        this.error_msg = false;
        this.page = "update";
        this.report_tag = this.list;
        this.$root.$emit("bv::show::modal", "reportingtag");
      });
    },
    addOption() {
      this.report_tag.tag_options.push({
        is_active: true,
        label: ""
      });
    },
    changeTagStatus(id, status) {
      this.$store
        .dispatch("reportingtag/changeStatus", {
          tag_id: id,
          status: status
        })
        .then(() => {
          //to show the alert message for success or error after api call
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message,
            type: this.type,
            showCloseButton: true
          });
          store.dispatch("reportingtag/fetchLists", {
            sort: this.sort,
            label: this.label
          });
        });
    },
    deleteReportingTag() {
      this.submitted = true;
      this.$store
        .dispatch("reportingtag/deletetag", {
          id: this.delete_id
        })
        .then(() => {
          //to show the alert message for success or error after api call
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message,
            type: this.type,
            showCloseButton: true
          });
          store.dispatch("reportingtag/fetchLists", {
            sort: this.sort,
            label: this.label
          });
          this.submitted = false;
        });
    },
    async onSubmit() {
      this.report_tag.tag_options = await this.report_tag.tag_options.filter(
        x => x.label != ""
      );
      if (this.report_tag.tag_options.length == 0) {
        this.addOption();
      }
      this.option_duplicate = await !(
        this.report_tag.tag_options.length ==
        new Set(this.report_tag.tag_options.map(x => x.label)).size
      );
      await this.$validator.validateAll().then(result => {
        if (result && !this.option_duplicate) {
          this.submitted = true;
          this.error_show = false;

          var data = JSON.stringify(this.report_tag);
          var url =
            this.page == "create" ? "createReportingTag" : "updateReportingTag";
          if (this.page == "update") {
            data = {
              id: this.report_tag.tag_id,
              data: JSON.stringify(this.report_tag)
            };
          }
          this.$store.dispatch("reportingtag/" + url, data).then(() => {
            this.submitted = false;
            if (this.type == "success") {
              this.error_msg = false;
              //to show the alert message for success or error after api call
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: this.message,
                type: this.type,
                showCloseButton: true
              });
              store.dispatch("reportingtag/fetchLists", {
                sort: this.sort,
                label: this.label
              });
              this.$refs.reportingtag.hide();
            } else {
              this.error_msg = true;
            }
          });
        } else {
          this.error_show = true;
        }
      });
    },
    removeOption(index, option) {
      if (this.report_tag.tag_options.length > 1) {
        if (option.hasOwnProperty("value")) {
          this.$store
            .dispatch("reportingtag/removeOption", {
              tag_id: this.report_tag.tag_id,
              value: option.value
            })
            .then(() => {
              if (this.type == "danger") {
                this.error_msg = true;
              } else {
                this.error_msg = false;
                this.report_tag.tag_options.splice(index, 1);
                this.option_duplicate = false;
              }
            });
        } else {
          this.report_tag.tag_options.splice(index, 1);
          this.option_duplicate = false;
          this.report_tag.tag_options = this.report_tag.tag_options.filter(
            x => x.label != ""
          );
        }
      }
    }
  },
  //routing
  beforeRouteEnter(routeTo, routeFrom, next) {
    getPageTags(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    getPageTags(routeTo, next);
  },
  //computed properties
  computed: {
    ...mapState({
      lists: state => state.reportingtag.lists,
      list: state => state.reportingtag.list,
      message: state => state.reportingtag.message,
      type: state => state.reportingtag.type
    })
  }
};
</script>